<template>
  <v-card v-if="properties != null" flat>
    <CImage
      v-if="properties.image != null"
      :url="properties.image"
      :alt="properties.title"
      size="100px"
    ></CImage>
    <div class="centered pt-4" v-if="properties.title != null">
      <PrimaryTitle :title="properties.title" :variant_color="variant_color"></PrimaryTitle>
    </div>
    <div class="centered" style="padding-top:20px">
      <span
        v-if="properties.subtitle"
        class="subsection-subtitle medium_grey--text"
      >{{ properties.subtitle }}</span>
    </div>
    <v-row v-if="properties != null">
      <v-col cols="12" md="6" v-if="properties.left != null">
        <FactoryComponent :component="properties.left" :variant_color="variant_color" />
      </v-col>
      <v-col cols="12" md="6" v-if="properties.right != null">
        <FactoryComponent :component="properties.right" :variant_color="variant_color" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import PrimaryTitle from "@/components/HomeSections/SubComponents/PrimaryTitle";
import CImage from "../SubComponents/Image";

export default {
  name: "TwoCols",
  props: {
    index: {
      type: Number,
      default: 0
    },
    properties: {
      type: Object,
      default: null
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PrimaryTitle, CImage
  }
};
</script>
